module.exports = "<div class=\"busyloader\"><div class=\"loadercircle modal-loader\"></div></div>";


//////////////////
// WEBPACK FOOTER
// ./~/html-loader!./~/pug-html-loader/lib!./src/app/common/templates/busy/modal.jade
// module id = 286
// module chunks = 0